import { noUsersSaysVideoLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoVideoItems from 'eco-design/sections/eco-video-items';
import { useRouter } from 'next/router';

import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.ListB');
    const { locale } = useRouter();
    const itemsA = [
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990284875/user_avatar_1.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192290/users_saying_1.jpg',
            title: t('item1_title'),
            useName1: t('item1_name1'),
            useName2: t('item1_name2'),
            videoSrc: 'https://www.youtube.com/embed/MgJ3-Wr-q2I?si=VsL6ZmztZlIpxhyc',
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990285251/user_avatar_2.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192664/users_saying_2.jpg',
            title: t('item2_title'),
            useName1: t('item2_name1'),
            useName2: t('item2_name2'),
            videoSrc: 'https://www.youtube.com/embed/EKJ-ivwfbMw?si=uX7WgM0Rh0db8IJx',
        },
        {
            logoIcon: 'https://websiteoss.ecoflow.com/upload/image/1740990285051/user_avatar_3.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1740990192449/users_saying_3.jpg',
            title: t('item3_title'),
            useName1: t('item3_name1'),
            useName2: t('item3_name2'),
            videoSrc: 'https://www.youtube.com/embed/yZavrHJsBAw?si=xCammue97ivCgGPc',
        },
    ];

    const joinLinksMap = {
        us: 'https://www.facebook.com/groups/efoutdoor',
        ca: 'https://www.facebook.com/groups/efoutdoor',
        uk: 'https://www.facebook.com/groups/ecoflowuk',
        de: 'https://www.facebook.com/groups/ecoflowclubdeutsch',
        fr: 'https://www.facebook.com/groups/ecoflowfrancophone',
        it: 'https://www.facebook.com/groups/ecoflowit',
    };

    const joinLink = joinLinksMap[locale as keyof typeof joinLinksMap];

    return (
        <div className={`${styles.comp}`}>
            <EcoSectionCommon
                sectionCommonLayout="left"
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn1')}
                lHref={joinLink}
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: 'none',
                    position: 'Collections_Join Facebook Group',
                }}
            />
            {!noUsersSaysVideoLocales.includes(locale as string) && (
                <>
                    <EcoSpaceSmall />
                    <EcoVideoItems items={itemsA} />
                </>
            )}
            <EcoSpace />
        </div>
    );
}
